module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('h3', {
    attrs: {
      "id": "download"
    }
  }, [_vm._v("ofo 共享单车 APP")]), _vm._v(" "), _c('p', [_vm._v("全新 1.8 版本，邀您共享")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "teach"
  }, [_c('h3', [_vm._v("使用方法")]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, _vm._l((_vm.docs), function(item) {
    return _c('div', {
      staticClass: "container"
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    }), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(item.h3)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.p)
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec06fe92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadContent.vue
// module id = 168
// module chunks = 1